import { getPromotionCodes } from '@atlassian/mpac-api-client';
import { hooks, log } from '@atlassian/mpac-utils';
export var usePromotionCodes = function usePromotionCodes(mpacBaseUrl, partnerId, promotionId) {
  var _hooks$usePromise = hooks.usePromise(function () {
    return getPromotionCodes(mpacBaseUrl, partnerId, promotionId);
  }),
      result = _hooks$usePromise.result,
      error = _hooks$usePromise.error,
      pending = _hooks$usePromise.pending;

  if (error) {
    log.error('PromotionCodes/hooks', "Failed to retrieve Promotion Codes", {
      error: error
    });
  }

  return {
    pending: pending,
    error: error,
    promotionCodes: result || []
  };
};